import ru from './ru';
import en from './en';
import fn from './fn';

export default { ru };